import { useDispatch, useSelector } from 'react-redux'
import { CloseIcon } from '../../../assets/icons/Svg'
import { clearTypeOfThirdModal } from '../../../features/modal/modalSlice'
import { useMemo, useState } from 'react'
import { addSelectedPopulateSpecialPackageItems, removeSelectedPopulateSpecialPackageItems, selectPopulatePackageItem, togglePopulateSpecialPackageItem } from '../../../features/client/clientSlice'
import { useCustomizePackageItemModalUserMemo } from '../../../hooks/use-memo/useCustomizePackageItemModalUseMemo'
import { PRODUCT_SIZE } from '../../../constant/constant'
import Button from '../../ui/Button'
import { GetSpecialPackageProducts } from '../../../features/client/clientInterface'
import SpecialPackageAddProductTHead from '../../common/theads/SpecialPackageAddProductTHead'
import SpecialPackageAddProductTBody from '../../common/tbody/SpecialPackageAddProductTBody'

interface CustomizePackageItemModalProps {
    packageProduct: GetSpecialPackageProducts[]
}

export default function CustomizePackageItemModal({ packageProduct }: CustomizePackageItemModalProps) {

    const dispatch = useDispatch()
    const [selectedType, setSelectedType] = useState(0);
    const selectedSpecialProduct = useSelector(selectPopulatePackageItem)
    const totalSelected = selectedSpecialProduct?.length ?? 0
    const { productTypes, filteredProducts, selectedProductIds } = useCustomizePackageItemModalUserMemo( packageProduct, selectedSpecialProduct, selectedType);
    const sortedProducts = useMemo(() => {
        return [...filteredProducts].sort((a, b) => {
            // Sort by type first
            if (a.type !== b.type) {
                return a.type - b.type;
            }
            // Then sort by size
            return a.sizeId - b.sizeId;
        });
    }, [filteredProducts]);
    
    return (
        <div className="fixed inset-0 m-0 p-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[102] overflow-hidden">
            <div className="relative w-[90vw] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75vw] lg:max-w-[60vw] lg:mx-auto overflow-hidden">
                <div className="flex flex-col w-full min-h-[50dvh] max-h-[80dvh] overflow-hidden">
                    <div className="flex flex-col py-5 h-full">
                        {/* Header */}
                        <div className="flex justify-between items-center py-1">
                            <div>
                                <p className="text-sm font-semibold leading-tight text-slate-900">
                                    {`Package Products`}
                                </p>
                                <p className="text-xs text-slate-500">
                                    Select the products to include in the client's package.
                                </p>
                            </div>
                            <button
                                type="button"
                                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center"
                                onClick={() => dispatch(clearTypeOfThirdModal())}
                            >
                                <CloseIcon />
                            </button>
                        </div>
                        <hr className="h-px bg-gray-200 border-0" />
                        <div className='w-full py-3'>
                            <div className='grid grid-cols-5 lg:grid-cols-7 gap-2'>
                                {productTypes.map((opt) => (
                                    <button
                                        key={opt.id}
                                        onClick={() => setSelectedType(opt.id)}
                                        className={`
                                            flex items-center gap-2
                                            border rounded px-1.5 py-1 transition-all
                                            ${
                                                selectedType === opt.id
                                                    ? "border-cbColor bg-cbColor text-white ring-cbColor"
                                                    : "border-gray-300 hover:border-gray-400"
                                            }
                                        `}
                                    >
                                        {/* <input
                                            type="checkbox"
                                            checked={selectedType === opt.id}
                                            readOnly
                                            className="h-3 w-3 accent-cbColor cursor-pointer"
                                        /> */}
                                        <span className="truncate text-xs">{opt.name}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                        <div className="flex items-center justify-between py-2">
                            <div>
                                <p className="text-xs font-semibold text-cbColor">
                                    {totalSelected} Selected product{totalSelected !== 0 && "s"}
                                </p>
                                <p className="text-xs font-semibold text-cbColor">
                                    {filteredProducts.length} Available product{filteredProducts.length !== 1 && "s"}
                                </p>
                            </div>
                            <div className="flex items-center gap-2">
                                <button
                                    onClick={() => dispatch(addSelectedPopulateSpecialPackageItems(filteredProducts))}
                                    className="rounded border border-cbColor px-3 py-0.5 text-xs font-medium text-cbColor transition hover:bg-cbColor hover:text-white"
                                >
                                    Select All
                                </button>
                                <button
                                    onClick={() => dispatch(removeSelectedPopulateSpecialPackageItems(filteredProducts))}
                                    className="rounded border border-red-400 px-3 py-0.5 text-xs font-medium text-red-500 transition hover:bg-red-500 hover:text-white"
                                >
                                    Clear All
                                </button>
                            </div>
                        </div>
                        <div className='flex-1 overflow-hidden bg-white rounded border'>
                            <div className='overflow-y-auto h-full'>
                                <table className='min-w-max w-full'>
                                    <SpecialPackageAddProductTHead/>
                                    <SpecialPackageAddProductTBody
                                        prod={sortedProducts}
                                        isLoading={false}
                                        isError={false}
                                        errorMessage={''}
                                        isEmpty={false}
                                        onClick={(product) => dispatch(togglePopulateSpecialPackageItem(product))}
                                        selectedProductIds={selectedProductIds}
                                    />
                                </table>
                            </div>
                        </div>
                        <div className='flex justify-end gap-2 mt-3'>
                            <Button
                                btnName='Done'
                                className='px-8 py-1 text-sm rounded bg-cbColor text-white'
                                onClick={() => dispatch(clearTypeOfThirdModal())}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
